import { render, staticRenderFns } from "./BincardIndex.vue?vue&type=template&id=afe4359c&scoped=true&"
import script from "./BincardIndex.vue?vue&type=script&lang=ts&"
export * from "./BincardIndex.vue?vue&type=script&lang=ts&"
import style0 from "./BincardIndex.vue?vue&type=style&index=0&id=afe4359c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe4359c",
  null
  
)

export default component.exports